import formatTableJson from '@younuo/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'name',
    label: '角色名称'
  },
  {
    filed: 'description',
    label: '描述'
  },
  {
    filed: 'createTime',
    label: '创建时间',
    type: 'time',
    width: '170'
  }
])
